import { useTranslation } from '@/contexts/i18n-context';
import { SvgProps } from './email';
import styles from './styles.module.css';
import clsx from 'clsx';

export function SuccessCircleSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.successCircle')}
      xmlns="http://www.w3.org/2000/svg"
      width="58"
      height="58"
      viewBox="0 0 58 58"
      className={clsx(className, styles.success)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8 0C12.8942 0 0 12.8942 0 28.8C0 44.7058 12.8942 57.6 28.8 57.6C44.7058 57.6 57.6 44.7058 57.6 28.8C57.6 12.8942 44.7058 0 28.8 0ZM28.8 51.84C16.0958 51.84 5.76 41.5042 5.76 28.8C5.76 16.0958 16.0958 5.76 28.8 5.76C41.5042 5.76 51.84 16.0958 51.84 28.8C51.84 41.5042 41.5043 51.84 28.8 51.84ZM39.6454 18.5105L43.7179 22.5829L25.92 40.4553L15.2438 29.7791L19.3162 25.7066L25.92 32.3103L39.6454 18.5105Z"
        fill="inherit"
      />
    </svg>
  );
}
